import type { DestinationMetadata } from '@/scopes/search/quick-search/domain/types'
import type { FilterOption } from '@/scopes/search/types'
import { useIntl } from '@/intl'
import { PartiallyHighlightedText } from '@/scopes/search/components/PartiallyHighlightedText'
import { tok } from '@sunwebgroup/ui-components'
import { Button, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${Typography} {
    ${Typography.modVariant('body-m-bold-tight')}
    text-align: left;
  }
`

const Subtitle = styled(Typography)``

const Btn = styled(Button)`
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  padding: ${tok('primitives_space_8')} ${tok('primitives_space_16')};
  text-align: left;

  border-radius: 0;
  min-height: initial;

  width: 100%;

  &:hover {
    background-color: ${tok('primitives_color_neutral_100')};
    border-radius: 6px;
  }

  ${Subtitle} {
    margin: 0;
    ${Typography.modVariant('body-s-regular-tight')}
  }
`

const StyledPartiallyHighlightedText = styled(PartiallyHighlightedText)`
  text-align: justify;
  margin-right: 0;
`

export function Destination({
  option,
  onItemClick,
  query,
}: {
  option: FilterOption<string, DestinationMetadata>
  onItemClick: (selection: FilterOption<string, DestinationMetadata>) => void
  query: string
}) {
  const intl = useIntl()
  return (
    <Btn key={option.value} variant="transparentNeutral" onClick={() => onItemClick(option)}>
      <Wrapper>
        <StyledPartiallyHighlightedText text={option.name} query={query} />
        <Typography>{option.resultsCount}</Typography>
      </Wrapper>
      {option.metadata?.parentName && option.metadata.type === 'Region' && (
        <Subtitle>
          {intl.formatMessage(
            { id: 'quicksearch_filter_destination_region_subtitle' },
            { country_name: option.metadata.parentName },
          )}
        </Subtitle>
      )}
      {option.metadata?.parentName && option.metadata.type === 'City' && (
        <Subtitle>
          {intl.formatMessage(
            { id: 'quicksearch_filter_destination_city_subtitle' },
            { region_name: option.metadata.parentName },
          )}
        </Subtitle>
      )}
    </Btn>
  )
}
